/**
 * The home-particles atlas frames the optimised type's textureId lane
 * indexes into (shared by the facade's renderer construction and the
 * departments' shape writes — single source of truth for the ids).
 *
 * The first four entries are the stage-1 demo cycle (screens/spaces/systems
 * pools cycle textureId over DEMO_FRAME_COUNT only); the triangle frames are
 * the icon department's ~12% syncRotation shapes
 * (IconParticleProcessor.initIcon).
 */
export const FRAME_NAMES = [
	'solid2.png',
	'solid.png',
	'solid-ring.png',
	'solid-square.png',
	'solid-tri.png',
	'solid-tri2.png'
];

export const FRAME_SOLID2 = 0;
export const FRAME_RING = 2; //'solid-ring.png' — screens drop machine / halftone rolls
export const FRAME_SQUARE = 3; //'solid-square.png' — the swirl's 5% square roll
export const FRAME_TRI = 4;
export const FRAME_TRI2 = 5;

/** Demo pools keep cycling the original four point shapes. */
export const DEMO_FRAME_COUNT = 4;
